import MainLayout from './mainLayout';

export interface LayoutProps {
	children?: React.ReactNode;
}

const Layout = (props: LayoutProps): JSX.Element => {
	return <MainLayout {...props} />;
};

export default Layout;
